module.exports = __webpack_public_path__ + "static/media/01 PAQUETE 1 ON INTERNET ALÁMBRICO TF 389.ab95fced.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetATF/01 PAQUETE 1 ON INTERNET ALÁMBRICO TF 389.pdf
// module id = 867
// module chunks = 0